import { TenantPackageConfig } from '~/tenants/common/registry';
import { MlmOrderContext, MlmOrderType } from '~/tenants/mlm/model/MlmOrder';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';
import MlmAerialConfig from '~/tenants/mlm/performable/aerial/MlmAerialConfig';

const MlmHeatPackageConfig: TenantPackageConfig = {
  id: 'heat',
  name: 'Heatin’ Up!',
  description: '',
  amount: '130.00',
  performables: [MlmPhotosConfig, MlmFloorplanConfig, MlmAerialConfig],
  eligible: (context) => (context as MlmOrderContext).metadata.type === MlmOrderType.RESIDENTIAL,
};

export default MlmHeatPackageConfig;
